import type { AppRouterWholesale } from '@repo/api/wholesale';
import { baseUrl } from '@repo/utils';
import { hc } from 'hono/client';

const url = baseUrl();

const client = hc<AppRouterWholesale>(url, {
  init: {
    credentials: 'include',
  },
});

export const apiClient = client.api;